module.exports = __webpack_public_path__ + "static/media/exit-arrow.891ab33b.svg";